import { buildDemoStudentsForClass } from "./buildDemoStudents";
import { DEMO_SCENARIO_CLASS_ID } from "./demoScenario";

/**
 * Visão gerencial da turma (demo) — KPIs, séries de gráficos,
 * alunos em atenção e insights (protótipo IA).
 */

function hashPick(seed, arr) {
  let h = 0;
  const s = String(seed);
  for (let i = 0; i < s.length; i += 1) {
    h = (31 * h + s.charCodeAt(i)) % 10007;
  }
  return arr[h % arr.length];
}

/**
 * @param {string} classId
 */
export function buildDemoClassOverview(classId) {
  const id = classId || DEMO_SCENARIO_CLASS_ID;
  const students = buildDemoStudentsForClass(id);
  const total = students.length || 8;

  const kpis = [
    {
      id: "attendance",
      label: "Frequência no período",
      value: "92%",
      hint: "últimas 4 semanas",
      tone: "ok"
    },
    {
      id: "occurrences",
      label: "Com ocorrência recente",
      value: `${Math.max(1, Math.round(total * 0.25))}`,
      hint: `de ${total} alunos · 15 dias`,
      tone: "warn"
    },
    {
      id: "below",
      label: "Abaixo da média",
      value: `${Math.max(1, Math.round(total * 0.2))}`,
      hint: "corte 6,0 · bimestre atual",
      tone: "alert"
    },
    {
      id: "plans",
      label: "Planos em dia",
      value: "78%",
      hint: "conteúdo efetivo vs previsto",
      tone: "warn"
    },
    {
      id: "coverage",
      label: "Frequência lançada",
      value: "85%",
      hint: "aulas do mês com registro",
      tone: "ok"
    }
  ];

  const attendanceTrend = {
    labels: ["Sem 1", "Sem 2", "Sem 3", "Sem 4"],
    datasets: [
      {
        label: "Frequência %",
        data: [94, 91, 89, 92],
        borderColor: "#00b297",
        backgroundColor: "rgba(0, 178, 151, 0.12)",
        fill: true,
        lineTension: 0.3,
        pointRadius: 4
      }
    ]
  };

  const occurrencesByType = {
    labels: ["Pedagógica", "Disciplinar", "Positiva", "Falta just."],
    datasets: [
      {
        label: "Ocorrências (30 dias)",
        data: [6, 4, 9, 3],
        backgroundColor: ["#34657f", "#ec0000", "#00b297", "#5c8398"]
      }
    ]
  };

  const reasons = [
    "Queda de frequência nas últimas 2 semanas",
    "Ocorrências disciplinares acumuladas",
    "Notas abaixo do corte em 2 disciplinas",
    "Faltas concentradas às segundas"
  ];

  const attentionStudents = students.slice(0, Math.min(6, total)).map((s, i) => {
    let severity = "low";
    if (i < 2) severity = "high";
    else if (i < 4) severity = "medium";
    return {
      ra: s.ra,
      name: s.name,
      photo: s.photo,
      reason: hashPick(`${s.ra}-${i}`, reasons),
      severity
    };
  });

  const insights = [
    {
      id: "i1",
      title: "Padrão de faltas às segundas",
      body:
        "Três alunos da turma concentram faltas no início da semana. Vale cruzar com transporte e comunicação aos responsáveis.",
      tags: ["frequência", "família"]
    },
    {
      id: "i2",
      title: "Português com maior risco acadêmico",
      body:
        "A distribuição de notas em Português está mais espalhada que Matemática neste bimestre — 2 alunos próximos do corte.",
      tags: ["desempenho", "Português"]
    },
    {
      id: "i3",
      title: "Cobertura de plano de aula",
      body:
        "Planos das quintas estão com atraso relativo às demais. Coordenação pode alinhar expectativa com o professor da disciplina.",
      tags: ["operacional", "plano de aula"]
    }
  ];

  return {
    classId: id,
    className: id === DEMO_SCENARIO_CLASS_ID ? "Turma Demo · Fundamental I" : id,
    periodLabel: "1º bimestre · 2026",
    kpis,
    attendanceTrend,
    occurrencesByType,
    attentionStudents,
    insights,
    generatedAt: new Date().toISOString()
  };
}
